export const convertCurrency = function (money) {
	const cnNums = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
	const cnIntRadice = ["", "拾", "佰", "仟"];
	const cnIntUnits = ["", "万", "亿", "兆"];
	const cnDecUnits = ["角", "分", "毫", "厘"];
	const cnInteger = "整";
	const cnIntLast = "元";
	const maxNum = 999999999999999.9999;
	let integerNum, decimalNum, parts;
	let chineseStr = "";
	let fushu = "";
	if (money == "") return "";
	money = parseFloat(money);
	if (money >= maxNum) return "";
	if (money == 0) {
		chineseStr = cnNums[0] + cnIntLast + cnInteger;
		return chineseStr;
	}
	if (money < 0) {
		money = Math.abs(money);
		fushu = "负";
	}
	money = money.toString();
	money.indexOf(".") == -1
		? ((integerNum = money), (decimalNum = ""))
		: ((parts = money.split(".")), (integerNum = parts[0]), (decimalNum = parts[1].substr(0, 4)));
	if (parseInt(integerNum, 10) > 0) {
		let zeroCount = 0;
		for (let i = 0, IntLen = integerNum.length; i < IntLen; i++) {
			let n = integerNum.substr(i, 1);
			let p = IntLen - i - 1;
			let q = p / 4;
			let m = p % 4;
			if (n == "0") {
				zeroCount++;
			} else {
				if (zeroCount > 0) chineseStr += cnNums[0];
				zeroCount = 0;
				chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
			}
			if (m == 0 && zeroCount < 4) chineseStr += cnIntUnits[q];
		}
		chineseStr += cnIntLast;
	}
	if (decimalNum != "") {
		for (let i = 0, decLen = decimalNum.length; i < decLen; i++) {
			let n = decimalNum.substr(i, 1);
			if (n != "0") chineseStr += cnNums[Number(n)] + cnDecUnits[i];
		}
	}
	chineseStr == "" ? (chineseStr += cnNums[0] + cnIntLast + cnInteger) : decimalNum == "" ? (chineseStr += cnInteger) : "";
	return fushu + chineseStr;
};
export const toLocaleString = function (n) {
	if (!n) n = 0;
	// n是val值
	// xssz3是是否显示千分位
	// xssz1是显示多少位小数点
	if (localStorage.getItem("company") != null) {
		const company = JSON.parse(localStorage.getItem("company"));
		const xssz3 = Number(company.xssz3);
		const xssz1 = Number(company.xssz1);
		n = Number(n).toFixed(xssz1);
		if (n % 1 !== 0) {
			const length = n.toString().split(".")[1].length;
			if (xssz3 == 1) {
				return length > xssz1
					? Number(n).toLocaleString("zh", { maximumFractionDigits: xssz1 })
					: Number(n).toLocaleString("zh", { minimumFractionDigits: xssz1 });
			} else {
				return Number(n).toFixed(xssz1);
			}
		}
		if (xssz3 == 1) {
			return xssz1 !== 0 ? Number(n).toLocaleString("zh", { minimumFractionDigits: xssz1 }) : Number(n).toLocaleString();
		} else {
			return Number(n).toFixed(xssz1);
		}
	}
};
